module.exports = __webpack_public_path__ + "img/5.1d70f4fb.png";